import api from "./api";

const DashboardAPI = {
    getDatas: (id) => api.get(`/admin/dashboard/data/all`),
    getSaaSMetrics: () => api.get(`/admin/dashboard/saas-metrics`),
    getImport: () => api.get(`/admin/dashboard/import`)
};

export default DashboardAPI;

